'use strict';

import quickview from "./quickview";
import variant from './pages/product/variant';
import images from './pages/product/image';
import util from './util';
import customVideoPlayer from './pages/product/customVideoPlayer';
import analytics from './analytics';

/**
 * Initializes the immersive experience by showing a quickview modal and
 * executing various functions within its callback.
 */
function initImmersiveExperience() {
    // Show the quickview modal with the specified URL and callback
    if ($('#immersive_experience').length > 0) { // Check if the immersive experience container exists
        window.addEventListener("message", (event) => {
            if (event.data && event.data.type == "ProductSelected") {
                // Show the quickview modal with the specified URL and callback
                var urlPrdShow = util.appendParamsToUrl(Urls.getImmersiveProductUrl, {
                    pid: event.data.slug,
                    variant: event.data.variant,
                    format: 'ajax',
                    Quantity: '1',
                    source: 'cart',
                    from: 'immersive',
                    immersiveExperience: 'true'
                });

                quickview.show({
                    url: urlPrdShow,
                    callback: function () {
                        var productName = $(".edit-modal.immersive-experience .product-name");

                        // Remove the reinsurance panel from the quickview modal
                        $('.quickview-modal .reinsurance-panel').remove();
                        $('.quickview-mini-modal.isOpened .icon-close').trigger('click');

                        $(productName).html().trim() === '' && $(productName).hide();

                        // Execute the variant function
                        setTimeout(() => {
                            variant();
                        }, 1000);

                        analytics.openPDPOverlayImmersive(pid);

                        // Remove the placeholder element for Bazaarvoice summary
                        $(".pdp-main .product-info-mobile-only .bazaarvoice-summary-placeholder").remove();

                        // Position Bazaarvoice element after a delay
                        setTimeout(positionBazaarVoice, 500);

                        /**
                         * Positions the Bazaarvoice element on the page.
                         */
                        function positionBazaarVoice() {
                            var $BVContainer = ($(window).width() < 768)
                                ? $(".pdp-main .product-info-mobile-only")
                                : $(".pdp-main .product-info .bazaarvoice-summary-placeholder");
                            var $BVElement = $(".pdp-main .bv-reviews-and-qna-wrapper");
                            if ($BVContainer.length && $BVElement.length) {
                                if($(window).width() < 768) {
                                    $BVElement.css({
                                        "top": $BVContainer.position().top + $BVContainer.innerHeight(),
                                        "left": $BVContainer.position().left
                                    }).removeClass("hidden");
                                } else {
                                    $BVElement.css({
                                        "top": $BVContainer.position().top,
                                        "left": $BVContainer.position().left
                                    }).removeClass("hidden");
                                }
                            }
                        }
                        // Render the thumbnails
                        if ($('#thumbnails').length > 0) {
                            $('#thumbnails').empty();   // clear the list
                            images(); // populate the thumbnails
                        }

                        // Execute the custom video player function
                        customVideoPlayer();

                        function handleMiniCartInteractions() {
                            $('.minicart-close').trigger('click');
                            $('body').removeClass('immersive-experience');
                            $(".mini-cart-image a, .mini-cart-details a, .mini-cart-link-cart").on('click', function() {
                                var redirectTo = $(this).attr('href');
                                window.location.href = redirectTo;
                            });
                        }

                        $(".edit-modal.immersive-experience").on('click', '.close-button', function () {
                            handleMiniCartInteractions();
                        });

                        $('.immersive-experience').parent('.reveal-overlay').on('click',function(e){
                            if ($(e.target).hasClass('reveal-overlay') || $(e.target).hasClass('icon-close')) {
                                handleMiniCartInteractions();
                            }
                        });


                    }
                }, 'immersive-experience'); // immersive-experience is a custom class added on the modal to indentify it as an immersive experience
            }
        });
    }
}


export default {
    init : function () {
    // Initialize the immersive experience
    initImmersiveExperience();
    },
    initImmersiveExperience: initImmersiveExperience
};

export {initImmersiveExperience};